export default __webpack_public_path__ + "static/media/1986.465d5f3e.png";